export default __webpack_public_path__ + "static/media/frame.e642f872.png";